import React from 'react'

const PaddingLayout = ({children}) => {
  return (
    <div className='p-3 pt-6 pb-16'>{children}</div>
  )
}

export default PaddingLayout